import React, { useContext, useEffect, useState } from 'react';
import { Box, Button, Typography, TextField } from '@mui/material';
import _ from 'lodash';
import { FieldContext } from '../App';
import { Filepond, ImageRender, Input, Map } from '../components';
import { useDoc, useFirebase, useCol } from '../hooks';
import '../style/field-details.scss';
import { Timeline } from '../components/timeline';

export const FieldDetails = ({ setSelectedTab }) => {
    const [loading, setLoading] = useState(false);
    const [readyToDelete, setReadyToDelete] = useState(false);
    const { fieldId } = useContext(FieldContext);
    const [deletedItems, setDeletedItems] = useState({});
    const [newImages, setNewImages] = useState({});
    const { data: locationsData, updateRecord: updateLocations } =
        useCol('configurations');
    const { data, updateRecord, deleteRecord } = useDoc(`fields/${fieldId}`);
    const { storage } = useFirebase();
    const [update, setUpdate] = useState({});

    const addImage = async () => {
        await Object.values(newImages).map(async (cur) => {
            const storageRef = storage.ref();

            var uploadTask = await storageRef
                .child(`fields/${fieldId}/${cur.name}`)
                .put(cur);

            const downloadURL = await uploadTask.ref.getDownloadURL();

            updateRecord({
                posters: [...update.posters, downloadURL],
            });
        });
    };

    const deleteImage = async () => {
        try {
            await Object.keys(deletedItems).map(async (cur) => {
                const posterRef = storage.refFromURL(data.posters[cur]);

                await posterRef.delete();
            });
        } catch (err) {
            console.error(err);
        }
    };

    const addNewLocations = async () => {
        if (update.info?.locations)
            return await updateLocations('locations', {
                LOCATIONS: [
                    ..._.find(locationsData, ['id', 'locations'])?.LOCATIONS,
                    ...update.info.locations,
                ],
            });
    };

    const updateData = async () => {
        setLoading(true);
        try {
            await deleteImage();

            await addNewLocations();
            await updateRecord(update);
            await addImage();
            setLoading(false);
        } catch (err) {
            console.error(err);
        }
    };
    const deleteField = async () => {
        setLoading(true);
        try {
            await data.posters.map(async (cur) => {
                const posterRef = storage.refFromURL(cur);

                await posterRef.delete();
                return 0;
            });
            await deleteRecord(`fields/${fieldId}`);

            setSelectedTab('List');
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        if (data && !loading)
            setUpdate({
                ...update,
                posters: data.posters.filter(
                    (_, index) => !deletedItems[index]
                ),
            });
    }, [deletedItems, data]);

    if (!data || loading) return <Typography h1>Loading</Typography>;
    return (
        <Box
            overflow="scroll"
            fullWidth
            height="84vh"
            className="detail-container"
            p={3}
        >
            <Timeline fieldId={fieldId} />
            {readyToDelete ? (
                <Box
                    p={2}
                    display="flex"
                    flexDirection="row"
                    alignItems="center"
                    justifyContent="flex-end"
                >
                    <Button
                        width={'100px'}
                        onClick={deleteField}
                        variant="contained"
                        color="error"
                    >
                        Устгах
                    </Button>
                    <Button
                        width={'100px'}
                        style={{ marginLeft: '30px' }}
                        onClick={() => setReadyToDelete(false)}
                        variant="contained"
                    >
                        Болих
                    </Button>
                </Box>
            ) : (
                <Box
                    p={2}
                    display="flex"
                    flexDirection="row"
                    alignItems="center"
                    justifyContent="flex-end"
                >
                    <Button
                        width={'100px'}
                        onClick={() => setReadyToDelete(true)}
                        variant="contained"
                        color="error"
                    >
                        Заал устгах
                    </Button>
                </Box>
            )}
            <Box p={2} display="flex" flexDirection="row" alignItems="center">
                <Typography>Нэр:</Typography>
                <Box m={1} />
                <TextField
                    fullWidth
                    variant="outlined"
                    defaultValue={data?.name}
                    onChange={(e) =>
                        setUpdate({ ...update, name: e.target.value })
                    }
                />
            </Box>
            <Box p={2} display="flex" flexDirection="row" alignItems="center">
                <Typography>Үндсэн хаяг:</Typography>
                <Box m={1} />
                <TextField
                    fullWidth
                    variant="outlined"
                    // placeholder=''
                    defaultValue={data?.mainLocation}
                    onChange={(e) =>
                        setUpdate({ ...update, mainLocation: e.target.value })
                    }
                />
            </Box>
            <Box p={2} display="flex" flexDirection="row" alignItems="center">
                <Typography>Түгээмэл Байршил:</Typography>
                <Input
                    value={data?.info.locations}
                    inputType="advantages"
                    placeholder="Locations"
                    freeSolo
                    noOptions
                    onTextChange={(change) =>
                        setUpdate({
                            ...update,
                            info: { ...update.info, locations: change },
                        })
                    }
                />
            </Box>
            <Box p={2} display="flex" flexDirection="row" alignItems="center">
                <Typography>Бүтэн үнэ:</Typography>
                <Box m={1} />
                <TextField
                    type="number"
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ step: 1000 }}
                    fullWidth
                    variant="outlined"
                    defaultValue={data?.price.fullPrice}
                    onChange={(e) =>
                        setUpdate({
                            ...update,
                            price: { ...update.price, fullPrice: e.target.value }
                        })
                    }
                />
            </Box>
            <Box p={2} display="flex" flexDirection="row" alignItems="center">
                <Typography>Хагас үнэ:</Typography>
                <Box m={1} />
                <TextField
                    type="number"
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ step: 1000 }}
                    fullWidth
                    variant="outlined"
                    defaultValue={data?.price.halfPrice}
                    onChange={(e) =>
                        setUpdate({
                            ...update,
                            price: {...update.price, halfPrice: e.target.value}
                        })
                    }
                />
            </Box>
            <Box p={2} display="flex" flexDirection="row" alignItems="center">
                <Typography>Шалны материал:</Typography>
                <Box m={1} />
                <TextField
                    fullWidth
                    variant="outlined"
                    defaultValue={data?.info.floorMaterial}
                    onChange={(e) =>
                        setUpdate({
                            ...update,
                            info: {
                                ...update.info,
                                floorMaterial: e.target.value,
                            },
                        })
                    }
                />
            </Box>
            <Box
                padding={2}
                fullWidth
                display="flex"
                flexDirection="row"
                alignItems="center"
                justifyContent="space-between"
            >
                <Box display="flex" flexDirection="row" alignItems="center">
                    <Typography>Үнэлгээ:</Typography>
                    <Box m={1} />
                    <Input
                        label="Одоор"
                        inputType="size"
                        step="0.1"
                        value={data?.rate}
                        onTextChange={(text) =>
                            setUpdate({ ...update, rate: text })
                        }
                    />
                </Box>
                <Box m={'0 5'} />
                <Box display="flex" flexDirection="row" alignItems="center">
                    <Typography>Цаг:</Typography>
                    <Box m={1} />
                    <Input
                        inputType="time"
                        value={data?.timeTable.open}
                        label="Нээх цаг:"
                        placeholder="default"
                        onTextChange={(text) =>
                            setUpdate({
                                ...update,
                                timeTable: {
                                    ...update.timeTable,
                                    open: text,
                                },
                            })
                        }
                    />
                    <Box m={1} />
                    <Input
                        inputType="time"
                        value={data?.timeTable.close}
                        label="Хаах цаг:"
                        placeholder="default"
                        onTextChange={(text) =>
                            setUpdate({
                                ...update,
                                timeTable: {
                                    ...update.timeTable,
                                    close: text,
                                },
                            })
                        }
                    />
                </Box>

                <Box m={'0 5'} />
                <Box display="flex" flexDirection="row" alignItems="center">
                    <Typography>Заалны:</Typography>
                    <Box m={1} />
                    <Input
                        label="Урт:"
                        inputType="size"
                        step="1"
                        variant="outlined"
                        value={data?.info.size.length}
                        onTextChange={(text) =>
                            setUpdate({
                                ...update,
                                info: {
                                    ...update.info,
                                    size: {
                                        ...update.size,
                                        length: text
                                    },
                                },
                            })
                        }
                    />
                    <Box m={1} />
                    <Input
                        label="Өргөн:"
                        inputType="size"
                        step="1"
                        variant="outlined"
                        value={data?.info.size.width}
                        onTextChange={(text) =>
                            setUpdate({
                                ...update,
                                info: {
                                    ...update.info,
                                    size: {
                                        ...update.size,
                                        width: text
                                    },
                                },
                            })
                        }
                    />
                </Box>
            </Box>
            <Box p={2} display="flex" flexDirection="row" alignItems="center">
                <Typography>Давуу талууд:</Typography>
                <Box m={1} />
                <Input
                    value={data?.info.advantages}
                    inputType="advantages"
                    placeholder="Advantages"
                    onTextChange={(change) =>
                        setUpdate({
                            ...update,
                            info: { ...update.info, advantages: change },
                        })
                    }
                />
            </Box>
            <Box p={2} display="flex" flexDirection="row" alignItems="center">
                <Typography>Утасны дугаарууд:</Typography>
                <Box m={1} />
                <Input
                    value={data?.info.phoneNumbers}
                    inputType="advantages"
                    placeholder={'Phone numbers'}
                    freeSolo
                    noOptions
                    onTextChange={(change) =>
                        setUpdate({
                            ...update,
                            info: { ...update.info, phoneNumbers: change },
                        })
                    }
                />
            </Box>
            <Map
                coordinate={data?.coordinate}
                setCoordinate={(coordinate) =>
                    setUpdate({
                        ...update,
                        coordinate: coordinate,
                    })
                }
            />
            <Box m={4} />
            <Box className="image-box">
                <ImageRender
                    data={data}
                    deletedItems={deletedItems}
                    setDeletedItems={setDeletedItems}
                />
                <Filepond images={newImages} setImages={setNewImages} />
            </Box>
            <Box m={4} />
            <Button
                fullWidth
                onClick={updateData}
                variant="contained"
                color="primary"
            >
                save
            </Button>
        </Box>
    );
};
